<template>
    <div class="z-blockquote">
        <div class="z-blockquote__container">
            <div class="z-blockquote__body">
                <blockquote class="z-blockquote__text">
                    <slot></slot>
                </blockquote>
            </div>
        </div>

        <div class="z-blockquote__author" v-if="author">
            <span
                v-if="author.name"
                class="z-blockquote__name"
                v-html="author.name"
            ></span>
            <span
                v-if="author.description"
                class="z-blockquote__description"
                v-html="author.description"
            ></span>
        </div>
    </div>
</template>

<script setup>
defineProps({
    author: Object
});
</script>

<style lang="scss" src="./index.scss"></style>
